import { render, staticRenderFns } from "./OperatnBaseResourceManager.vue?vue&type=template&id=1d1e2376&scoped=true&"
import script from "./OperatnBaseResourceManager.vue?vue&type=script&lang=ts&"
export * from "./OperatnBaseResourceManager.vue?vue&type=script&lang=ts&"
import style0 from "./OperatnBaseResourceManager.vue?vue&type=style&index=0&id=1d1e2376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e2376",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VFabTransition,VIcon,VSpacer,VSubheader})
